import React, { useEffect, useState } from "react";
import './css/AttendanceCalendar.css';
import TopBar from "./TopBar";
import axios from "./../axios";

const AttendanceCalendar = () => {
  const today = new Date();
  const [isLoading, setIsLoading] = useState(true);

  const [currentDate, setCurrentDate] = useState({
    year: today.getFullYear(),
    month: today.getMonth(),  
  });

  const { year, month } = currentDate;

  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const [attendanceData, setAttendanceData] = useState({
    "2000-06-01": "Present" 
  });

  useEffect(() => {
    const GetAtt = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem('student_token');
        const attendance = await axios.get('student/attendance', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAttendanceData(attendance.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    GetAtt();
  }, []);

  const getStatusClass = (status) => {
    switch (status) {
      case "Present":
        return "present";
      case "Absent":
        return "absent";
      case "Leave":
        return "leave";
      case "Holiday":
        return "holiday";
      default:
        return "none";
    }
  };

  const handleMonthChange = (direction) => {
    let newMonth = month + direction;
    let newYear = year;

    if (newMonth < 0) {
      newMonth = 11;
      newYear -= 1;
    } else if (newMonth > 11) {
      newMonth = 0;
      newYear += 1;
    }

    setCurrentDate({ year: newYear, month: newMonth });
  };

  const getMonthName = (monthIndex) => {
    return new Date(0, monthIndex).toLocaleString('default', { month: 'long' });
  };

  const getDayName = (day) => {
    const date = new Date(year, month, day);
    return date.toLocaleString('default', { weekday: 'short' });
  };

  return (
    <div>
      <TopBar title={'Attendance'} />
      {isLoading ? (
        <div className="calendar-skeleton">
          <div className="calendar-header">
            <button disabled>« Prev</button>
            <h3>{getMonthName(month)} {year}</h3>
            <button disabled>Next »</button>
          </div>
          <div className="calendar">
            {[...Array(daysInMonth)].map((_, i) => (
              <div key={i} className="day-box skeleton-box">
                <div className="day-name skeleton-text"></div>
                <div className="day-number skeleton-text"></div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <>
          <div className="calendar-header">
            <button onClick={() => handleMonthChange(-1)}>« Prev</button>
            <h3>{getMonthName(month)} {year}</h3>
            <button onClick={() => handleMonthChange(1)}>Next »</button>
          </div>
          <div className="calendar">
            {[...Array(daysInMonth)].map((_, i) => {
              const day = i + 1;
              const dateKey = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
              const status = attendanceData[dateKey] || "None";
              const dayName = getDayName(day);

              return (
                <div key={i} className={`day-box ${getStatusClass(status)}`}>
                  <div className="day-name">{dayName}</div>
                  <div className="day-number">{day}</div>
                  <div className="status" style={{ display: 'contents' }}>{status}</div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default AttendanceCalendar;